import React from 'react';
export function Footer() {
  return <footer className="bg-brand-navy px-4 py-12 text-center text-sm text-white/70" data-id="element-80" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-81" data-mp="3gg0za3iktxxn">
        <div className="mb-3 font-display text-xl font-bold text-white" data-id="element-82" data-mp="3gh3ng3oilm9v">🎨 ARTE PRONTA</div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/60" data-id="element-83" data-mp="32m1awxp5wyo3">
          Il curricolo artistico completo e pronto all&apos;uso per la scuola primaria e secondaria italiana, per
          insegnanti e famiglie.
        </p>
        <nav aria-label="Note legali" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-84" data-mp="38za4uuqp54h">
          <a href="#termini" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-85" data-mp="3ldan5eqbi1jd">
            Termini e Condizioni
          </a>
          <a href="#privacy" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-86" data-mp="3qf9qwppyz0gu">
            Privacy
          </a>
          <a href="#contatti" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-87" data-mp="2eyt8cnj4c3pr">
            Contatti
          </a>
        </nav>
        <p data-id="element-88" data-mp="3l9sk795mt0ql">© 2026 ARTE PRONTA™ — Tutti i diritti riservati.</p>
      </div>
    </footer>;
}